/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Processing_Event_GroupInputs */



/**
* | output |
* | --- |
* | "Processing Event Group..." |
*
* @param {Ateliere_Connect_Status_Processing_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_processing_event_group = /** @type {((inputs?: Ateliere_Connect_Status_Processing_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Processing_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traitement du groupe d’événements...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verarbeitung der Ereignisgruppe...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elaborazione del gruppo di eventi in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обработка группы событий...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Procesando grupo de eventos...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在处理事件组...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント グループを処理中...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह की प्रक्रिया चल रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Processando o grupo de eventos...")
	return /** @type {LocalizedString} */ ("Processing Event Group...")
});